import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import AppDataTable from "../../../../components/common/AppDataTable";
import AppStatusSwitch from "../../../../components/common/AppStatusSwitch";

import { Supplier } from "../types";

interface SupplierTableProps {
  rows: Supplier[];
  loading: boolean;
  page: number;
  pageSize: number;
  rowCount: number;

  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;

  onEdit: (supplier: Supplier) => void;
  onDelete: (supplier: Supplier) => void;

  onStatusChange: (
    supplier: Supplier,
    checked: boolean
  ) => void;
}

const SupplierTable = ({
  rows,
  loading,
  page,
  pageSize,
  rowCount,
  onPageChange,
  onPageSizeChange,
  onEdit,
  onDelete,
  onStatusChange,
}: SupplierTableProps) => {
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Supplier Name",
      flex: 1.5,
      minWidth: 220,
    },

    {
      field: "code",
      headerName: "Code",
      flex: 1,
      minWidth: 140,
    },

    {
      field: "contactPerson",
      headerName: "Contact Person",
      flex: 1.2,
      minWidth: 180,
    },

    {
      field: "phone",
      headerName: "Phone",
      flex: 1,
      minWidth: 150,
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      minWidth: 220,
    },

    {
      field: "city",
      headerName: "City",
      flex: 1,
      minWidth: 140,
    },

    {
      field: "status",
      headerName: "Status",
      width: 160,
      sortable: false,

      renderCell: (params) => (
        <AppStatusSwitch
          checked={params.row.status === "ACTIVE"}
          onChange={(checked) =>
            onStatusChange(params.row, checked)
          }
        />
      ),
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 110,

      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => onEdit(params.row)}
        />,

        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => onDelete(params.row)}
        />,
      ],
    },
  ];

  return (
    <AppDataTable
      rows={rows}
      columns={columns}
      loading={loading}
      rowCount={rowCount}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
};

export default SupplierTable;